module.exports = __webpack_public_path__ + "img/sxmj.fb705159.png";